/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOilGasOff = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="m20.586 22.85.707.707 1.414-1.414-20-20-1.414 1.414 6.676 6.676L2.923 22.85h2.964L12 19.03l6.113 3.82h2.473zm-5.654-5.654 2.882 2.882.12.302-4.047-2.53 1.045-.654zm-1.451-1.451L12 16.67l-3.561-2.226.238-.595h2.909l1.895 1.895zM9.586 11.85l-.078-.078-.031.078h.109zm5.09-5 2.962 7.404-3.59-3.59-.725-1.814h-1.088l-2-2H11a2 2 0 0 0-2-2v-2a3.99 3.99 0 0 1 3 1.354 3.99 3.99 0 0 1 3-1.354v2a2 2 0 0 0-2 2h1.677zm-4.563 11-4.048 2.53 1.62-4.048 2.428 1.518z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOilGasOff as OilGasOff };
